import { Action } from '@ngrx/store';

export * from './announcements.actions';
export * from './auth.actions';
export * from './bulk-request.actions';
export * from './check-ins.actions';
export * from './customer-files.actions';
export * from './customer-team.actions';
export * from './customers.actions';
export * from './feedback.actions';
export * from './file-upload.actions';
export * from './invite.actions';
export * from './location.actions';
export * from './memo-categories.actions';
export * from './organisations.actions';
export * from './profile.actions';
export * from './reset.actions';
export * from './router.actions';
export * from './staff.actions';
export * from './statistics.actions';
export * from './storage-sync.actions';

export const NETWORK_ERROR = '[Network] error';
export const ORG_CONTEXT_CHANGE = '[Meta][Context] Change Organisation';
export const APPLICATION_AUTHORIZED = '[Application] Auth OK';
export const APPLICATION_READY = '[Application] Ready';

export class CAAction implements Action {
  readonly type: string;
  public payload: any;
}

export class NetworkError implements Action {
  readonly type = NETWORK_ERROR;
  constructor(public payload: any) {}
}

/**
 * Initial required requests have all fired and the first screen can be shown
 */
export class ApplicationReady implements Action {
  readonly type = APPLICATION_READY;
  constructor() {}
}

/**
 * Initial required requests have all fired and the user is logged in
 */
export class ApplicationAuthorized implements Action {
  readonly type = APPLICATION_AUTHORIZED;
  constructor(public payload: any = {}) {}
}

export const OrgContextChange = (): Action => ({ type: ORG_CONTEXT_CHANGE });
